// @flow
import React, { Component } from 'react';
import { AnyAction } from 'redux';
import { connect } from 'react-redux';
import gql from 'graphql-tag';
import _filter from 'lodash/filter';
import { sanitizeRouteParams } from 'metaup/routing/routingUtils';
import type { Routes } from 'metaup/routing/routingUtils';
import { listOfflineTokens, revokeOfflineToken } from './model/OfflineToken.client';
import { apolloMutate } from '../core/data/apolloClient';
import ErrorCapsule from '../core/exceptions/ErrorCapsule';
import OfflineTokensListPageView from './views/OfflineTokensListPageView';
import type { OfflineTokensListPageViewProps } from './views/OfflineTokensListPageView';
import type { OfflineToken } from './model/OfflineToken.model';

type OfflineTokensListState = {
  tokens: null | Array<OfflineToken> | ErrorCapsule,
}

const tokenShape = `{ id token officeId isActive deviceInfo boundDeviceId createdAt revokedAt expiresAt }`;

const initialState = { tokens: null };

const ACTION_SET_TOKENS = 'offlineTokens/list/ACTION_SET_TOKENS';
const ACTION_REMOVE_TOKEN = 'offlineTokens/list/ACTION_REMOVE_TOKEN';

function setTokens(tokens) {
  return { type: ACTION_SET_TOKENS, tokens };
}

async function loadTokens() {
  try {
    const tokens = await listOfflineTokens(null, tokenShape);
    return setTokens(tokens);
  } catch (err) {
    return setTokens(new ErrorCapsule(err, () => [
      setTokens(initialState.tokens), loadTokens(),
    ]));
  }
}

async function revokeToken(token) {
  await apolloMutate(
    gql`mutation ($input: OfflineTokenRevoke!) {
          revokeOfflineToken(input: $input) { id isActive }
        }`,
    { input: { token } }
  );
  return { type: ACTION_REMOVE_TOKEN, token };
}

export function offlineTokensListReducer(state = initialState, action) {
  switch (action.type) {
    case ACTION_SET_TOKENS:
      return { ...state, tokens: action.tokens };
    case ACTION_REMOVE_TOKEN:
      return {
        ...state,
        tokens: state.tokens instanceof Array
          ? state.tokens.map(t => t.token === action.token ? { ...t, isActive: false, revokedAt: new Date().toISOString() } : t)
          : state.tokens,
      };
    default: return state;
  }
}

const OfflineTokensListPage = connect(
  ({ offlineTokens }) => ({ tokens: offlineTokens.list.tokens }),
)(class extends Component<OfflineTokensListPageViewProps> {
  constructor(props) {
    super(props);
    props.dispatch([setTokens(null), loadTokens()]);
  }
  componentWillUnmount() {
    this.props.dispatch(setTokens(null));
  }
  render() {
    return (
      <OfflineTokensListPageView
        {...this.props}
        onRevokeToken={(token) => this.props.dispatch(revokeToken(token))}
      />
    );
  }
});

export function offlineTokensListPageRoutes(): Routes {
  return [{
    title: 'Офлайн токены',
    path: '/offline-tokens/',
    isEnabled: ({ isUser }) => isUser,
    render: params => <OfflineTokensListPage {...sanitizeRouteParams(params, {})} />,
    design: null,
  }];
}
